export default {
	MARK_ALERT: 'MARK_ALERT',
	CREATE_BROADCAST: 'CREATE_BROADCAST',
};
